export default __webpack_public_path__ + "static/image_contact_s@2x-b03061d5238852a9c3fc7fc18b50bf33.jpg";